/**
 * Faz 1.9 — Sembol görünen adları (symbol_code → display_name).
 *
 * Gateway initial_state.symbol_labels'tan beslenir (branch override → tenant
 * display_name → katalog adı zinciri gateway'de çözülür). fp-symbol-cell render
 * anında okur; yoksa ham sembol koduna düşer.
 *
 * Module-level store — initial_state layout render'ından ÖNCE set edilir, böylece
 * cell'ler oluşturulurken label hazırdır. Reconnect'te yeni initial_state tüm
 * layout'u yeniden render eder → cell'ler taze label okur.
 */
let labels: Record<string, string> = {};

export function setSymbolLabels(map: Record<string, string> | undefined | null): void {
  labels = map ?? {};
}

export function getSymbolLabel(code: string): string | undefined {
  return labels[code];
}
